// Servicio para manejar las operaciones de la API de encuestas
class EncuestaService {
  constructor() {
    //this.baseURL = "http://localhost:8084/encuesta"
    // this.baseURL = "/api-encuesta/encuesta/" // obsoleto: ya no se usa ruta relativa
    this.baseURL = "https://parking-club.com/api-encuesta/encuesta"
    
  }

  /**
   * Guarda una nueva encuesta en el servidor
   * @param {Object} encuestaData - Datos de la encuesta
   * @returns {Promise<Object>} - Respuesta del servidor
   */
  async saveEncuesta(encuestaData) {
    try {
      const response = await fetch(`${this.baseURL}/save-encuesta`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(encuestaData),
      })

      if (!response.ok) {
        const errorData = await response.text()
        throw new Error(`Error ${response.status}: ${errorData}`)
      }

      return await response.json()
    } catch (error) {
      console.error("Error en saveEncuesta:", error)
      throw error
    }
  }

  /**
   * Formatea los datos del formulario para enviar al servidor
   * @param {Object} formData - Datos del formulario
   * @returns {Object} - Datos formateados
   */
  formatEncuestaData(formData) {
    return {
      nombre_parking: formData.nombre_parking,
      ubicacion: formData.ubicacion,
      preciotarifa: Number.parseFloat(formData.preciotarifa),
      latitud: Number.parseFloat(formData.latitud),
      longitud: Number.parseFloat(formData.longitud),
      plazas: Number.parseInt(formData.plazas, 10),
      descripcion: formData.descripcion || null,
      horaApertura: formData.horaApertura ? `${formData.horaApertura}:00` : null,
      horaCierre: formData.horaCierre ? `${formData.horaCierre}:00` : null,
      estado_encuesta: 0, // Siempre 0 como valor por defecto
      nombre_contacto: formData.nombre_contacto,
      telefono_contacto: formData.telefono_contacto,
      email_contacto: formData.email_contacto,
    }
  }
}

// Crear una instancia única del servicio
const encuestaService = new EncuestaService()

export default encuestaService
